import { useState, SyntheticEvent, useEffect } from 'react';
import { Stack, Snackbar, Alert } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';

import { Navigate, useLocation } from 'react-router-dom';
import './AuthorizationPage.style.scss';
import { errorHandler } from '../../services/errorHandler';
import { login } from '../../services/autorization';
import FormAuth from '../../components/FormAuth/FormAuth';
import { FormState } from '../../interfaces/user';

const AuthorizationPage = () => {
  const { isLogin, responseCode } = useAppSelector((state) => state.user);
  const location = useLocation();
  const dispatch = useAppDispatch();

  const [showSnack, setShowSnack] = useState(false);
  const errorText = errorHandler(responseCode);

  const onSubmitFormAction = (data: FormState) => {
    setShowSnack(false);
    dispatch(login(data));
    if (responseCode) {
      setShowSnack(true);
    }
  };

  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowSnack(false);
  };

  useEffect(() => {
    if (responseCode) {
      setShowSnack(true);
    }
  }, [responseCode]);

  if (isLogin) {
    return <Navigate to="main" state={{ from: location }} replace />;
  }
  return (
    <>
      <FormAuth onSubmitFormAction={onSubmitFormAction} />
      <Stack>
        <Snackbar open={showSnack} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
            {errorText}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};
export default AuthorizationPage;
